<template>
  <section>
    <b-sidebar title="Edit Milestone" v-model="showEditMilestone" right shadow>
      <edit-milestone :data="milestoneData" @saved="onChange" />
    </b-sidebar>

    <b-alert variant="secondary" show>
      <b-row cols="12" class="mb-1 alert-heading">
        <b-col class="d-flex align-items-center justify-content-between">
          <b-form-checkbox
            checked="true"
            hideShowFilter="true"
            @change="hideShowFilter"
            ><b>show filters</b></b-form-checkbox
          >
          <b-input-group style="width: 400px" class="input-group-merge">
            <b-input-group-prepend is-text class="left-br-10">
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              placeholder="Search"
              v-model="filters.search"
              @input="onSearch"
              class="right-br-10"
            />
          </b-input-group>
          <b-button
            right
            size="sm"
            variant="gradient-success"
            :disabled="exportExcelLoading"
            @click="downloadExcel"
          >
            <span class="text-nowrap"> Export Milestones excel </span>
            <b-spinner v-if="exportExcelLoading" small class="ml-1" />
          </b-button>
          <!-- <b-dropdown
            right
            size="sm"
            text="Actions"
            variant="gradient-secondary"
            id="dropdown-form"
            ref="dropdown"
          >
            <b-dropdown-form>
              <b-button
                block
                size="sm"
                class="w-100"
                variant="gradient-success"
                @click="downloadCSV"
              >
                <span class="text-nowrap"> Export Milestones csv </span>
              </b-button>
              <b-button
                block
                size="sm"
                class="w-100"
                variant="gradient-success"
                @click="downloadExcel"
              >
                <span class="text-nowrap"> Export Milestones excel </span>
              </b-button>
            </b-dropdown-form>
          </b-dropdown> -->
        </b-col>
      </b-row>
    </b-alert>

    <b-row v-if="this.filtersHidden == false">
      <!-- <b-col sm="12" md="4" lg="4">
        <b-input-group class="input-group-merge mb-1">
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-prepend>
          <b-form-input
            placeholder="Search"
            v-model="filters.search"
            @input="onSearch"
          />
        </b-input-group>
      </b-col> -->
      <b-col sm="12" md="2" lg="2">
        <master-select
          class="mb-1 borderRadius-10"
          v-model="filters.milestone"
          label="lbl_name"
          :reduce="(lbl) => lbl.lbl_id"
          :options="$store.state.master.milestone"
          :loading="this.$store.state.master.loading.milestone"
          aria-placeholder="Milestone"
          placeholder="Milestone Name"
          @input="onFiltersChange"
        />
      </b-col>
      <b-col sm="12" md="2" lg="2">
        <master-select
          class="mb-1 borderRadius-10"
          v-model="filters.contract_nature"
          :options="contract_natures"
          aria-placeholder="Contract Nature"
          placeholder="Nature of Contract"
          @input="onFiltersChange"
        />
      </b-col>
      <b-col sm="12" md="4" lg="4">
        <master-select
          class="mb-1 borderRadius-10"
          v-model="filters.movie"
          :options="$store.state.master.movies"
          :loading="this.$store.state.master.loading.movies"
          :filter-by="movieFilter"
          label="name"
          :reduce="(movie) => movie.id"
          placeholder="Movie"
          @input="onFiltersChange"
          @search="onSearchMovie"
        />
      </b-col>
      <b-col sm="12" md="4" lg="4">
        <master-select
          class="mb-1 borderRadius-10"
          v-model="filters.vendor"
          :options="$store.state.master.vendors"
          :loading="this.$store.state.master.loading.vendors"
          label="company"
          :reduce="(vendor) => vendor.vendor_id"
          placeholder="Customer"
          @input="onFiltersChange"
          @search="onSearchCustomer"
        />
      </b-col>
      <!-- <b-col sm="12" md="2" lg="2">
        <flat-pickr
          :config="{
            mode: 'range',
            ...$flatPickrConfig,
          }"
          placeholder="Planned Date"
          class="form-control mb-1"
          v-model="filters.duedate"
          @input="onFiltersChange"
        />
      </b-col> -->
      <b-col sm="12" md="4" lg="4" class="mt-">
        <div class="d-block text-left">
          <label>Planned date from</label>
          <flat-pickr
            v-model="filters.duedateFrom"
            :config="{
              ...$flatPickrConfig,
            }"
            placeholder="Date From"
            class="form-control mb-1 borderRadius-10"
            @input="onFiltersChange"
          />
        </div>
      </b-col>
      <b-col sm="12" md="4" lg="4" class="mt-">
        <div class="d-block text-left">
          <label>Planned date to</label>
          <flat-pickr
            v-model="filters.duedateTo"
            :config="{
              ...$flatPickrConfig,
            }"
            placeholder="Date To"
            class="form-control mb-1 borderRadius-10"
            @input="onFiltersChange"
          />
        </div>
      </b-col>
      <b-col sm="12" md="4" lg="4" class="mt-2">
        <b-form-checkbox
          v-model="filters.duedateEmpty"
          id="textareaduedatedate"
          @input="onFiltersChange"
          >Show Empty planned dates</b-form-checkbox
        >
      </b-col>

      <b-col sm="12" md="4" lg="4" class="mt-">
        <div class="d-block text-left">
          <label>Actual date from</label>
          <flat-pickr
            v-model="filters.actualdateFrom"
            :config="{
              ...$flatPickrConfig,
            }"
            placeholder="Date From"
            class="form-control mb-1 borderRadius-10"
            @input="onFiltersChange"
          />
        </div>
      </b-col>
      <b-col sm="12" md="4" lg="4" class="mt-">
        <div class="d-block text-left">
          <label>Actual date to</label>
          <flat-pickr
            v-model="filters.actualdateTo"
            :config="{
              ...$flatPickrConfig,
            }"
            placeholder="Date To"
            class="form-control mb-1 borderRadius-10"
            @input="onFiltersChange"
          />
        </div>
      </b-col>
      <b-col sm="12" md="4" lg="4" class="mt-2">
        <b-form-checkbox
          v-model="filters.actualdateEmpty"
          @input="onFiltersChange"
          id="textareaactualdate"
          >Show Empty actual dates</b-form-checkbox
        >
      </b-col>

      <b-col sm="12" md="4" lg="4" class="mt-">
        <div class="d-block text-left">
          <label>Payment date from</label>
          <flat-pickr
            v-model="filters.paymentdateFrom"
            :config="{
              ...$flatPickrConfig,
            }"
            placeholder="Date From"
            class="mb-1 borderRadius-10"
            @input="onFiltersChange"
          />
        </div>
      </b-col>
      <b-col sm="12" md="4" lg="4" class="mt-">
        <div class="d-block text-left">
          <label>Payment date from</label>
          <flat-pickr
            v-model="filters.paymentdateTo"
            :config="{
              ...$flatPickrConfig,
            }"
            placeholder="Date To"
            class="form-control mb-1 borderRadius-10"
            @input="onFiltersChange"
          />
        </div>
      </b-col>
      <b-col sm="12" md="4" lg="4" class="mt-2">
        <b-form-checkbox
          v-model="filters.paymentdateEmpty"
          id="textareapaymentdate"
          placeholder="Payment date filters will visible here"
          @input="onFiltersChange"
          >Show Empty payment dates</b-form-checkbox
        >
      </b-col>

      <!-- <b-col sm="12" md="2" lg="2">
        <flat-pickr
          :config="{
            mode: 'range',
            ...$flatPickrConfig,
          }"
          placeholder="Payment Date"
          class="form-control mb-1"
          v-model="filters.paymentdate"
          @input="onFiltersChange"
        />
      </b-col> -->

      <b-col sm="6" md="2" lg="2">
        <b-button
          size="sm"
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          variant="outline-secondary"
          class="w-100 mt-2 mb-3 borderRadius-10"
          @click="clearFilters"
          >Reset</b-button
        >
      </b-col>
    </b-row>
    <b-card no-body v-if="$can('read', 'contract')">
      <b-table
        hover
        small
        bordered
        class="position-relative"
        primary-key="id"
        responsive
        :empty-text="tableEmptyText"
        show-empty
        :items="milestonesList"
        :fields="fields"
        @row-clicked="onRowClicked"
      >
        <!-- hover -->
        <template #head(sr)="data">
          <b-badge v-if="pagination.totalRows" variant="success">{{
            pagination.totalRows
          }}</b-badge>
        </template>
        <template #cell(sr)="data">
          <div style="width: max-content">
            {{
              data.index + 1 + (pagination.currentPage - 1) * pagination.limit
            }}

            <br />
            <div
              @click.stop="
                $router.push(`/contracts/form/${data.item.contract_id}`)
              "
            >
              <b-badge variant="light-primary"
                >{{
                  `#C${data.item.contract_nature[0]}${data.item.contract_id}`
                }}
              </b-badge>
              <br />
              <b-badge variant="light-primary"
                >{{ `${data.item.contract_nature}` }}
              </b-badge>
            </div>
          </div>
        </template>
        <template #cell(titles)="data">
          <div style="width: max-content" v-html="data.value"></div>
        </template>
        <template #cell(amountpaid)="data">
          {{ formatCurrency(data.value) }}
        </template>
        <template #cell(amountpayable)="data">
          <span class="w100">{{ `${formatCurrency(data.value)} ${data.item.currency_code ? data.item.currency_code: ''}` }}</span>
        </template>
        <template #cell(payable)="data">
          {{ formatCurrency(data.value) }}
        </template>
        <template #cell(actualdate)="data">
          <div style="width: max-content">
            {{ data.value ? moment(data.value).format("DD-MM-YYYY") : "" }}
          </div>
        </template>

        <template #cell(paymentdate)="data">
          <div style="width: max-content">
            {{ data.value ? moment(data.value).format("DD-MM-YYYY") : "" }}
          </div>
        </template>
        <template #cell(duedate)="data">
          <div style="width: max-content">
            {{ data.value ? moment(data.value).format("DD-MM-YYYY") : "" }}
          </div>
        </template>

        <template #cell(invoiceReceivedAmount)="data">
          <b-row style="display: flex; justify-content: start; min-width: 280px; max-width: 280px;">
            <b-col>
              <b-badge pill variant="warning">
                Add multiple invoice
                </b-badge>
            </b-col>
            <b-col class="mr-1">
              <b-form-checkbox
                switch
                inline
                v-model="data.item.show_multiple_invoice"
                @input="handleShowMultipleInvoice(data.index)"
                :disabled="(data.item.vendor_milestones_invoice || []).length > 0 || data.item.invoice_unique_id"
                >
                </b-form-checkbox>
              </b-col>
          </b-row>
          <b-row>
            <b-col v-if="!data.item.show_multiple_invoice" class="text-nowrap">
              <b-form-input
                style="width: 150px"
                placeholder="Invoice No."
                v-model="data.item.invoice_unique_id"
              />

              <p>
                Total Amt:
                <b
                  >{{ formatCurrency(data.item.invoice_total) }}
                  {{ data.item.invoiceCurrency }}</b
                >
              </p>
              <p>
                Paid Amt:
                <b
                  >{{ formatCurrency(data.item.invoiceReceivedAmount) }}
                  {{ data.item.invoiceCurrency }}</b
                >
              </p>
              <p>Exh. Rt: {{ data.item.invoiceExRate }}</p>
              <b-button
                @click="
                  () => {
                    showModal('Are you sure want to save?', 'save').then(
                      (value) => {
                        if (value) onSaveMilestoneInv(data.item);
                      }
                    );
                  }
                "
                size="sm"
                variant="outline-success"
                >save</b-button
              >
              <b-button
                @click="
                  () => {
                    showModal('Are you sure you want to remove the invoice?', 'remove').then(
                      (value) => {
                        if (value) handle_reset_invoice(data.item);
                      }
                    );
                  }
                "
                size="sm"
                variant="outline-danger"
                class="ml-1"
                >Reset</b-button
              >
            </b-col>
            <b-col v-else style="">
              <div class="d-flex flex-column col text-nowrap p-1" v-for="(invoice,index) of data.item.vendor_milestones_invoice" :key="index">
                <div class="d-flex">
                  <p>{{ index + 1 }})</p>
                  <p class="pr-1"><b-badge variant="success">Invoice No</b-badge>:{{invoice.invoice_id}}</p>
                </div>
                <div style="">
                  <p class="pr-1">Milestone Amt: <b>{{invoice.invoice_amount_milestone}}</b></p>
                  <p class="pr-1">Amt Paid: <b>{{invoice.paid_amount ? invoice.paid_amount :"0.00"}}</b></p>
                  <p class="pr-1">Total Amt: <b>{{invoice.total_amount ? invoice.total_amount :"0.00"}}</b></p>
                  <p class="pr-1">Balance Amt: <b>{{invoice.balance ? invoice.balance :"0.00"}}</b></p>
                </div>
                <b-button
                  size="sm"
                  :hidden="viewOnly"
                  @click.stop="
                    () => {
                      showModal('Are you sure want to remove?', 'remove').then(
                        (value) => {
                          if (value) handle_mul_invoice_remove(invoice);
                        }
                      );
                    }
                  "
                  variant="danger"
                  style="width: 6rem"
                >
                remove
                </b-button>
              </div>
              <div class="d-flex flex-column">
                <b-form-input
                  style="width: 150px"
                  placeholder="Invoice No."
                  v-model="data.item.mul_inv_number"
                />
                <b-button
                @click="
                  () => {
                    showModal('Are you sure want to save?', 'save').then(
                      (value) => {
                        if (value) onSaveMilestoneInv(data.item);
                      }
                    );
                  }
                "
                size="sm"
                variant="outline-success"
                style="width: 60px; margin-top: 5px;"
                >save</b-button
              >
              </div>
            </b-col>
          </b-row>
        </template>
        <!-- <template #cell()="data">
          <div style="position: relative; display:flex; justify-content:center ; align-items:center">
            <feather-icon
              style="cursor: pointer"
              icon="InfoIcon"
              size="23"
              @mouseenter="handleContractHoveredSet(data.item.contract_id)"
              @mouseleave="handleContractReleased(data.item.contract_id)"
            />
            <div
              v-if="hoveredContractId === data.item.contract_id"
              style="
                position: absolute;
                bottom: 100%;
                transform: translateX(-50%),translateY(-1%);
                background-color: rgb(31, 48, 122);
                color: white;
                border-radius: 0.25rem;
                text-align: center;
                width: max-content;
                min-width: 15rem;
                min-height:5rem;
                height:max-content;
                padding: 1rem;
                font-size: 10px;
                white-space: nowrap;
                box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
                margin-top: 2%;
                display:flex;
                flex-direction:column;
                justify-content:center;
                align-items:center;
                font-family: verdana;
              "
            >
              <div
                v-if="data.item.updatedAt"
                style="display: flex; gap: 0.5rem"
              >
                <div>UPDATED AT:</div>
                <div>{{ data.item.updatedAt }}</div>
              </div>
              <div
                v-if="data.item.updatedBy_user"
                style="display: flex;  gap: 0.5rem"
              >
                <div>UPDATED BY:</div>
                <div>{{ data.item.updatedBy_user }}</div>
              </div>
              <div
                v-if="data.item.createdAt"
                style="display: flex; gap: 0.5rem"
              >
                <div>CREATED AT:</div>
                <div>{{ data.item.createdAt }}</div>
              </div>
              <div
                v-if="data.item.createdBy"
                style="display: flex; gap: 0.5rem"
              >
                <div>CREATED BY:</div>
                <div>{{ data.item.createdBy_user }}</div>
              </div>
            </div>
          </div>
        </template> -->

        <template #cell(additionalMilestoneData)="data">
          <div style="display: flex;justify-content: center;align-items: center;">
                  <feather-icon
                    style="cursor: pointer"
                    icon="InfoIcon"
                    size="23"
                    @mouseenter="handleHoveredMilestone(data.item.milestone_id)"
                    @mouseleave="handleRemovedMilestone(data.item.milestone_id)"
                  />
                </div>
          <div v-if="hoveredMilestoneId === data.item.milestone_id">
          <hover-metadata-component
            :item="data.item"
            :idField="'milestone_id'"
            :createdAt="data.item.createdAt"
            :createdBy="data.item.createdBy_name"
            :updatedAt="data.item.updatedAt"
            :updatedBy="data.item.updatedBy_name"
            :isHovered="hoveredMilestoneId === data.item.milestone_id"
            :showAbove="data.index >= itemsInRow - 3? true : false "
          />
        </div>

       
        </template>
        
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <b-button-group size="sm" vertical>
              (M:{{ data.item.id }})
              <b-badge
                size="sm"
                @click="editMilestone(data.item)"
                v-if="$can('update', 'contract') && !data.item.deleted"
                variant="success"
                >Update Milestone</b-badge
              >

              <!-- <hr /> -->
              <!-- <b-badge
                variant="info"
                size="sm"
                @click.stop="
                  $router.push(`/contracts/form/${data.item.contract_id}`)
                "
                >View Contract</b-badge
              > -->
              <!-- <hr />
              <b-badge size="sm" variant="success"
                >Create Invoice - (M:{{ data.item.id }})</b-badge
              > -->
            </b-button-group>
          </div>
        </template>
        <template #cell(comment)="data">
          <span class="text-nowrap">{{ data.value }}</span>
        </template>
        <template #cell()="data">
          <span class="text-nowrap">{{ data.value }}</span>
        </template>
      </b-table>

      <template #footer>
        <div>
          <b-row>
            <b-col
              class="d-flex align-items-end justify-content-end justify-content-sm-center"
            >
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.totalRows"
                :per-page="pagination.limit"
                @change="onChange"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
                :limit="15"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-card>
  </section>
</template>

<script>
import {
  BCard,
  BBadge,
  BTable,
  BCol,
  BRow,
  BButton,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BPagination,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BModal,
  VBTooltip,
  VBToggle,
  BSidebar,
  BFormCheckbox,
  BAlert,
  BDropdownForm,
  BButtonGroup,
  BFormTextarea,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import * as ContractServices from "@/apiServices/ContractServices";
import * as RevenueServies from "@/apiServices/RevenueServies";
import { contract_natures, labels } from "@/utils/constants";
import { downloadFromURL, formatCurrency } from "@/utils/helpers";
import EditMilestone from "./EditMilestone.vue";
import ToastificationContentVue from "@/@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import { TokenService } from "@/apiServices/storageService";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import showModal from "../../../components/ModalConfirmation";
import HoverMetadataComponent from "@/views/components/HoverMetadataComponent.vue";

export default {
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  components: {
    AppCollapse,
    AppCollapseItem,
    BCard,
    BBadge,
    BTable,
    BCol,
    BRow,
    BButton,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BPagination,
    FeatherIcon,
    BDropdown,
    BDropdownItem,
    BTooltip,
    BModal,
    vSelect,
    flatPickr,
    EditMilestone,
    BSidebar,
    BFormCheckbox,
    BAlert,
    BDropdownForm,
    BButtonGroup,
    BFormTextarea,
    HoverMetadataComponent
  },
  data() {
    return {
      tableEmptyText: "LOADING...",
      exportExcelLoading: false,
      hoveredMilestoneId:null,
      contract_natures,
      filterModal: {
        dateFrom: "",
        dateTo: "",
        emptyDates: false,
      },

      filterName: "",
      // contract_statuses,
      filters: {
        search: "",
        milestone: "",
        contract_nature: "",
        vendor: "",
        movie: "",
        duedateFrom: "",
        duedateTo: "",
        actualdateFrom: "",
        actualdateTo: "",
        paymentdateFrom: "",
        paymentdateTo: "",
        duedateEmpty: false,
        paymentdateEmpty: false,
        actualdateEmpty: false,
      },

      pagination: {
        currentPage: 1,
        limit: 10,
        totalRows: 0,
        perPageOptions: [10, 25, 50, 100, "All"],
      },
      fields: [
        {
          key: "actions",
          label: "Actions",
          stickyColumn: true,
          variant: "primary",
        },
        {
          key: "sr",
          label: "SR",
        },
        {
          key: "company",
          label: "Contact",
        },
        {
          key: "titles",
          label: "Movie",
        },
        {
          key: "milestone_name",
          label: "Name",
        },
        {
          key: "amountpaid",
          label: "Amount Paid",
        },
        {
          key: "amountpayable",
          label: "Amount Payable",
        },
        {
          key: "payable",
          label: "Payable %",
        },
        {
          key: "duedate",
          label: "Planned Date",
        },
        {
          key: "actualdate",
          label: "Actual Date",
        },

        {
          key: "invoiceReceivedAmount",
          label: "Invoice Details",
          variant: "success",
        },
        {
          key: "comment",
          label: "Comment",
        },
        {
          key: "paymentdate",
          label: "Payment Date",
        },
        {
           key:"additionalMilestoneData",
           label:"LOGS"
        },
      ],
      milestonesList: [],
      milestoneData: {},
      showEditMilestone: false,
      selectedContractId: null,
      filtersHidden: false,
      filterSelected: null,
      searchMovieTerm: "",
      searchCustomerTerm: "",
      invoices_data:[],
      itemsInRow: 10,
    };
  },
  methods: {
    showModal,

    moment,
    handleHoveredMilestone(id){
      this.hoveredMilestoneId = id;
    },
    handleRemovedMilestone(){
       this.hoveredMilestoneId = null;
    },
    async onSaveMilestoneInv(data) {
      try {
        console.log(data,'fjeoifh')
        const invoiceNumber = data.show_multiple_invoice 
          ? data.mul_inv_number
          : data.invoice_unique_id;
        const response = await RevenueServies.UpdateInvoiceDataService({
          inv_number: invoiceNumber,
          milestone_id: data.id,
          data:data,
          show_multiple_invoice:data.show_multiple_invoice
        });
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.loadMilestonesList();
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.loadMilestonesList();
        }
      } catch (error) {
        console.error("Error in onSaveMilestoneInv ", error);
      }
    },
    hideShowFilter() {
      this.filtersHidden = !this.filtersHidden;
    },
    formatCurrency,

    onRowClicked(item, index, event) {
      if (this.$can("update", "contract") && !item.deleted) {
        this.editMilestone(item);
      }
    },

    downloadCSV() {
      try {
        const token = TokenService.getToken();

        if (!token) {
          alert("Error in getting token");
        }

        let urlStr = `${process.env.VUE_APP_BASEURL}/contract/sheet/milestone/download?authorization=${token}`;

        downloadFromURL(urlStr, "Milestone", "csv");
      } catch (error) {
        console.error(`Error in downloadCSV `, error);
      }
    },

    downloadExcel() {
      if (this.exportExcelLoading) return;

      this.exportExcelLoading = true;

      let url = null;
      let excelName = "";
      let payload = {
       ...this.filters
      };
      url = `${process.env.VUE_APP_BASEURL}/contract/sheet/milestone/download/elsx`;

      fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/Json",
          authorization: localStorage.getItem("access_token"),
          "x-access-token": localStorage.getItem("access_token"),
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.blob())
        .then((blob) => {
          const anchorElement = document.createElement("a");
          document.body.appendChild(anchorElement);
          anchorElement.style.display = "none";
          excelName = "MilestoneSheet.xlsx";
          var url = window.URL.createObjectURL(blob);
          anchorElement.href = url;
          anchorElement.download = excelName;
          anchorElement.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err, "error in onExport Milestone Sheet Excel");
        })
        .finally(() => {
          this.exportExcelLoading = false;
        });
    },

    movieFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      // console.log("Filtering:", { option, search });
      return (
        option.name && option.name.toString().toLowerCase().indexOf(temp) > -1
      );
    },

    clearFilters() {
      this.filters = {
        search: "",
        status: "",
        contract_nature: "",
        vendor: "",
        movie: "",
        territories: [],
        rights: [],
        languages: [],
        from: "",
        to: "",
      };
      this.pagination = {
        ...this.pagination,
        currentPage: 1,
        limit: 10,
        totalRows: 0,
      };
      this.onChange();
    },

    onFiltersChange() {
      this.pagination.currentPage = 1;
      this.onChange();
    },

    editMilestone(data) {
      this.showEditMilestone = true;
      this.milestoneData = data;
    },

    async getMilestones() {
      const loader = this.$loading.show();

      try {
        const response = await ContractServices.getAllMilestones({
          limit: this.pagination.limit,
          page: this.pagination.currentPage,
          ...this.filters,
        });
        if (!response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message || "Failed",
              icon: "EditIcon",
              variant: "primary",
            },
          });
          return;
        }

        this.milestonesList = response.data.data.milestones.map((item) => ({
          ...item,
          show_multiple_invoice: item.vendor_milestones_invoice.length > 0  ? true : false,
          mul_inv_number:null
        }));
        this.itemsInRow = this.milestonesList.length;

        if (response.data.data.count) {
          this.pagination.totalRows = response.data.data.count;
        }
        if (!this.milestonesList.length)
          this.tableEmptyText = "NO RECORDS FOUND";
      } catch (error) {
        console.error("Error in getting milestones List ", error);
        this.tableEmptyText = "Error in getting milestones";
      } finally {
        loader.hide();
      }
    },

    onChange() {
      this.$nextTick(() => {
        this.getMilestones();
        localStorage.setItem(
          "filtersAndPaginationMilestones",
          JSON.stringify({
            filters: this.filters,
            pagination: this.pagination,
          })
        );
      });
    },

    onSearch() {
      if (this.debouce) clearTimeout(this.debouce);
      this.debouce = setTimeout(() => {
        this.onFiltersChange();
      }, 1000);
    },

    loadMilestonesList() {
      const filtersAndPaginationMilestonesStr = localStorage.getItem(
        "filtersAndPaginationMilestones"
      );
      if (filtersAndPaginationMilestonesStr) {
        const obj = JSON.parse(filtersAndPaginationMilestonesStr);
        this.pagination = obj.pagination;
        this.filters = obj.filters;
      }
      this.getMilestones();
    },
    onSearchMovie(searchMovieTerm) {
      return;
      this.searchMovieTerm = searchMovieTerm;
      this.$store.dispatch("master/setMoviesMaster", {
        search: searchMovieTerm,
      });
    },
    onSearchCustomer(searchCustomerTerm) {
      return;
      this.searchCustomerTerm = searchCustomerTerm;
      this.$store.dispatch("master/setVendorsMaster", {
        search: searchCustomerTerm,
      });
    },

    handleShowMultipleInvoice(index){
      
      this.milestonesList[index].show_multiple_invoice == true ? false : true
      this.milestonesList[index].show_multiple_invoice == true ? false : true
      console.log(this.milestonesList,"foiewhfoiwehoi")
    },

    async handle_reset_invoice(data){
      try {
        const payload ={
          milestone_id:data.id,
          invoice_unique_id:data.invoice_unique_id,
        }
        const response = await RevenueServies.revert_vendor_milestones_invoice(payload);
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.loadMilestonesList();
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        console.error("Error in getting milestones List ", error);
      }
    },

    async handle_mul_invoice_remove(data){
      try {
        console.log('data',data)
        const payload ={
          ...data,
        }
        const response = await RevenueServies.mul_invoice_remove(payload);
        if (response.data.status) {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.loadMilestonesList();
        } else {
          this.$toast({
            component: ToastificationContentVue,
            props: {
              title: response.data.message,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        console.error("Error in getting milestones List ", error);
      }
    }
  },

  mounted() {
    this.loadMilestonesList();

    this.$store.dispatch("master/setVendorsMaster");
    this.$store.dispatch("master/setMoviesMaster");

    this.$store.dispatch("master/setLabelMaster", { key: labels.milestone });
  },
};
</script>

<style lang="scss">
.w100{
  display: block;
  min-width: 100px;
}

.borderRadius-10 {
  & .vs__dropdown-toggle {
    border-radius: 10px !important;
  }
  border-radius: 10px !important;
}

.left-br-10 {
  & .input-group-text {
    border-radius: 10px 0 0 10px !important;
  }
  border-radius: 10px 0 0 10px !important;
}

.right-br-10 {
  border-radius: 0 10px 10px 0 !important;
}
</style>
